import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import TextInput from "./TextInput";
import { isValidEmail } from "../CrackersUtil";
import { raisePostRequest } from "../AxiosAPI";
import { CrackersContext } from "../CrackersContext";

function Support () {
    const captionName = 'Enter your Name', captionEmail = 'Enter your Email to communicate';
            // captionMobNumber = "Enter your 10 digit mobile phone number";
    const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage } = useContext(CrackersContext);
    const [name, setName] = useState('');
    // const [mobNumber, setMobNumber] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [emailValidation, setEmailValidation] = useState({});
    const [messageValidation, setMessageValidation] = useState({});

    useEffect(() => {
        setIsZeroCasePage(true);
    }, [])

    const validateEmail = (email) => {
        const error = {};
        if (!email) {
            error.validation = false;
            error.reason = "Email is required";
        } else if (!isValidEmail(email)) {
            error.validation = false;
            error.reason = "Invalid Email";
        }
        if (Object.keys(error).length > 0) {
            setEmailValidation(error);
        } else {
            setEmailValidation({ "validation": true});
        }
    };

    const validateMessage = (message) => {
        const error = {};
        if(!message || message.trim() === '') {
            error.reason = "Message is required";
            error.validation = false;
        }
        if(Object.keys(error).length > 0) {
            setMessageValidation(error);
        } else {
            setMessageValidation({"validation" : true})
        }
    }

    const clear = () => {
        setName('');
        // setMobNumber('');
        setEmail('');
        setMessage('');
        setEmailValidation({});
        setMessageValidation({});
    }

    const addQuery = async () => {
        validateEmail(email);
        validateMessage(message);
        const validation = emailValidation.validation && messageValidation.validation;
        if(validation) {
            const response = await raisePostRequest("/crackers/add-support-query/", {"name" : name ? name : null, "email" : email, "message" : message}, null, setShowErrorToastStatus, setToastBody);
            setEmailValidation({});
            setMessageValidation({});
            clear();
        }
    }

    return(
        <>
            <div style={{marginTop : "10%"}}>
                <Row>
                    <Col xs={1} md={2} lg={4}></Col>
                    <Col xs={10} md={8} lg={4}>
                        <Row className="sup-comp" style={{ color: "white"}}>
                            <h4>Please raise your Query</h4>
                        </Row>
                        <Row className="sup-comp">
                            <TextInput caption={captionName}
                                value={name}
                                onChange={setName}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Name"}
                                validator={null}
                                isMultiLine={false} />
                        </Row>
                        {/* <Row className="sup-comp">
                            <TextInput caption={captionMobNumber}
                                value={mobNumber}
                                onChange={setMobNumber}
                                validation={{}}
                                info={"We'll never share your mobile phone number with anyone else."}
                                onFocusCaption={"Mobile Number"}
                                validator={null}
                                isMultiLine={false} />
                        </Row> */}
                        <Row className="sup-comp">
                            <TextInput caption={captionEmail}
                                value={email}
                                onChange={setEmail}
                                validation={emailValidation}
                                info={"We'll never share your Email with anyone else."}
                                onFocusCaption={"Email"}
                                validator={validateEmail}
                                isMultiLine={false} />
                        </Row>
                        <Row className="sup-comp">
                            <TextInput caption={"Enter your Query/Message here..."}
                                value={message}
                                onChange={setMessage}
                                validation={messageValidation}
                                info={""}
                                onFocusCaption={"Message"}
                                validator={validateMessage}
                                isMultiLine={true} />
                        </Row>
                        <Row className="sup-comp">
                            <Col xs={6} md={8}></Col>
                            <Col xs={2} md={1}>
                                <Button as="button" onClick={clear} variant="light">Clear</Button>
                            </Col>
                            <Col xs={1} md={1}></Col>
                            <Col xs={2} md={1}>
                                <Button onClick={addQuery}>Submit</Button>
                            </Col>
                            <Col xs={1} md={1}></Col>
                        </Row>
                    </Col>
                    <Col md={2}></Col>
                </Row>
            </div>
        </>
    );
}

export default Support;